/* @jsx h */
import { defineComponent, h } from "vue";
import swissMadeSvg from "./swissmade.svg?raw";

type Props = {
  /** Rendered width in px; height follows the logo's aspect ratio. */
  width?: number;
};

/**
 * "Swiss made" badge, inlined so the lettering follows the theme's text colour
 * (`currentColor` → `text-base-content`) while the Swiss cross stays red/white.
 */
export const SwissMade = defineComponent<Props>({
  name: "SwissMade",
  props: ["width"],
  setup(props) {
    return () => (
      <span
        class="inline-block text-base-content [&>svg]:block [&>svg]:h-auto [&>svg]:w-full"
        style={{ width: `${props.width ?? 40}px` }}
        innerHTML={swissMadeSvg}
      />
    );
  },
});
